var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-input',{attrs:{"type":"text","placeholder":("" + (_vm.config.placeholder)),"clearable":""},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }